export const status = {
    BACKLOG: 'Backlog',
    TO_DO: 'To Do',
    IN_PROGRESS: 'In Progress',
    DONE: 'Done'
}
export const priority = {
    HIGH: 'High',
    MEDIUM: 'Medium',
    LOW: 'Low',
}